export const MANIFEST_TITLE = {
  br: 'Portal do Cliente',
  es: 'Portal del Cliente',
};
